import React from 'react'

class NavAusbildungsnachweise extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M16 7.75H9.25V1.5H4v17h12V7.75zm-.818-1.5L10.75 2.187V6.25h4.432zM17.5 20h-15V0h8.25l6.75 6.25V20zM7 14.5h6v1H7v-1z"
        />
      </svg>
    )
  }
}

export default NavAusbildungsnachweise
